// extracted by mini-css-extract-plugin
module.exports = {"suspensionPanel":"style_suspensionPanel___Dyim"};